import { ColDef } from 'ag-grid-community';
import { t } from 'i18next';

import { PricingProfileRuleStructureType } from 'pricing/enums';
import { IPricingProfile } from 'pricing/types';

import { ActionsCell, CriteriaCell, ValueCell } from './cells';

interface IColumnDefParams {
  pricingProfile: IPricingProfile;
  isEditable?: boolean;
}

const structureTypeValues = {
  [PricingProfileRuleStructureType.MARGIN]: t('labelMargin'),
  [PricingProfileRuleStructureType.DISCOUNT]: t('labelDiscount'),
};

export const getColumnDef = ({ pricingProfile, isEditable = true }: IColumnDefParams): ColDef[] => [
  {
    colId: 'actions',
    width: 80,
    maxWidth: 80,
    sortable: false,
    resizable: false,
    cellRenderer: ActionsCell,
    cellRendererParams: {
      pricingProfile,
      isEditable,
    },
    suppressColumnsToolPanel: true,
    pinned: 'left',
    lockPinned: true,
  },
  {
    colId: 'manufacturerName',
    headerName: t('headerManufacturer'),
    field: 'manufacturerName',
    filter: 'agTextColumnFilter',
    valueFormatter: ({ value }) => value || t('labelAll'),
    width: 200,
  },
  {
    colId: 'path',
    headerName: t('headerCategory'),
    field: 'categoryPath',
    filter: 'agTextColumnFilter',
    valueFormatter: ({ value }) => value || t('labelAll'),
    width: 300,
  },
  {
    colId: 'partFieldCriteria',
    headerName: t('headerPartSpecificationCriteria'),
    field: 'partFieldCriteria',
    sortable: false,
    cellRenderer: CriteriaCell,
    cellRendererParams: {
      criteriaFieldName: 'partFieldName',
    },
    minWidth: 200,
    flex: 1,
  },
  {
    colId: 'corporatePartFieldCriteria',
    headerName: t('headerCompanyPartSpecificationCriteria'),
    field: 'corporatePartFieldCriteria',
    sortable: false,
    cellRenderer: CriteriaCell,
    cellRendererParams: {
      criteriaFieldName: 'corporatePartFieldName',
    },
    minWidth: 200,
    flex: 1,
  },
  {
    colId: 'structureType',
    headerName: t('headerType'),
    field: 'structureType',
    filter: 'agSetColumnFilter',
    valueFormatter: ({ value }) => structureTypeValues[value],
    filterParams: {
      values: [PricingProfileRuleStructureType.MARGIN, PricingProfileRuleStructureType.DISCOUNT],
      valueFormatter: ({ value }) => structureTypeValues[value],
    },
    width: 150,
  },
  {
    colId: 'discount',
    headerName: t('headerValue'),
    field: 'discount',
    filter: 'agNumberColumnFilter',
    cellRenderer: ValueCell,
    width: 150,
  },
];
